var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('get-started',{attrs:{"label":_vm.companyName,"logoUrl":_vm.logoURL,"selectedLanguage":_vm.selectedLanguage,"languages":_vm.languages,"businessLoginAvailable":false},on:{"startClassic":_vm.start,"changeLanguage":_vm.changeLanguage}})}
var staticRenderFns = []

export { render, staticRenderFns }